import { readCookie } from './read-cookie';

type SignupAttribution = {
  rl_aid?: string;
  first_touch?: Record<string, unknown>;
  last_touch?: Record<string, unknown>;
};

function readJsonCookie(name: string): Record<string, unknown> | undefined {
  const raw = readCookie(name);
  if (!raw) return undefined;
  try {
    const parsed: unknown = JSON.parse(raw);
    return parsed && typeof parsed === 'object' && !Array.isArray(parsed)
      ? (parsed as Record<string, unknown>)
      : undefined;
  } catch {
    return undefined;
  }
}

export function signupAttribution(): SignupAttribution | undefined {
  const attribution: SignupAttribution = {};
  const aid = readCookie('rl_aid');
  if (aid) attribution.rl_aid = aid;
  const first = readJsonCookie('rl_touch');
  if (first) attribution.first_touch = first;
  const last = readJsonCookie('rl_touch_last');
  if (last) attribution.last_touch = last;
  return Object.keys(attribution).length > 0 ? attribution : undefined;
}
